// src/components/layouts/renderers/InstagramNewsFrame.tsx
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { InstagramNewsConfig, LayoutRendererProps } from '@/lib/layouts/types';
import { layoutHeadlineCss, SYSTEM_SANS } from '@/lib/layouts/headlineStyle';
import { useLayerFont } from '@/hooks/use-layer-font';

export const InstagramNewsFrame: React.FC<LayoutRendererProps<InstagramNewsConfig>> = ({ config, media }) => {
  useLayerFont(config.headlineFontFamily, config.headlineFontUrl);
  return (
    <AbsoluteFill style={{ backgroundColor: '#ffffff', display: 'flex', flexDirection: 'column', padding: 50, fontFamily: SYSTEM_SANS }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginBottom: 20, flexShrink: 0 }}>
        {config.avatarUrl
          ? <img src={config.avatarUrl} alt="" style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover' }} />
          : <div style={{ width: 72, height: 72, borderRadius: '50%', backgroundColor: '#d1d5db' }} />}
        <span style={{ fontSize: 38, fontWeight: 700, color: '#111' }}>{config.handle}</span>
        <span style={{ fontSize: 30, color: '#3897f0', marginLeft: 2 }}>✓</span>
      </div>
      <div style={{ flex: 1, minHeight: 0, width: '100%', overflow: 'hidden', backgroundColor: '#000', position: 'relative' }}>{media}</div>
      <div style={{ display: 'flex', gap: 30, fontSize: 46, color: '#111', marginTop: 20, flexShrink: 0 }}><span>♥</span><span>💬</span><span>↪</span></div>
      <div style={{ fontSize: 32, fontWeight: 700, color: '#111', marginTop: 8, flexShrink: 0 }}>{config.likes} curtidas</div>
      <div
        data-testid="layout-headline"
        data-autocut-over=""
        style={{
          marginTop: 8,
          flexShrink: 0,
          ...layoutHeadlineCss(config, { color: '#111', fontSize: 34, fontFamily: SYSTEM_SANS }),
        }}
      >
        <span style={{ fontWeight: 700 }}>{config.handle} </span>{config.caption}
      </div>
    </AbsoluteFill>
  );
};
